import RelatedProductsProvider from './hooks/useRelatedProducts';

import { RelatedProductsProps } from './@types/RelatedProductsProps';
import RelatedProductsContainer from './handles/RelatedProductsContainer';
import Title from './handles/Title';
import ContentContainer from './handles/ContentContainer';
import SliderLayout from '../../slider-layout/SliderLayout/SliderLayout';
import { SliderLayout as SliderProps } from '../../../templates/components/SliderLayout/templates';
type CanvasWidth = {
	canvasWidth: 1080 | 1024 | 427;
};

type AllProps = RelatedProductsProps & CanvasWidth;

const RelatedProducts = ({ canvasWidth, ...rest }: AllProps) => {
	const sliderProps = SliderProps().props;
	return (
		<RelatedProductsProvider {...rest}>
			<RelatedProductsContainer>
				<Title />
				<ContentContainer>
					<SliderLayout canvasWidth={canvasWidth} {...sliderProps} itemsPerPage={{ desktop: 4, tablet: 2, mobile: 1 }}>
						{rest.blocks}
					</SliderLayout>
				</ContentContainer>
			</RelatedProductsContainer>
		</RelatedProductsProvider>
	);
};

export default RelatedProducts;
